import React from "react";
import { useNavigate } from "react-router-dom";

interface ErrorDisplayProps {
  message: string;
  code?: string;
  details?: string;
  colors?: {
    accent: string;
    background: string;
    text: string;
  };
  buttonText?: string;
  buttonIcon?: React.ReactNode;
  onButtonClick?: () => void;
  image?: string;
}

const ErrorDisplay: React.FC<ErrorDisplayProps> = ({
  message,
  code,
  details,
  colors,
  buttonText = "Search Again",
  buttonIcon,
  onButtonClick,
  image,
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onButtonClick) {
      onButtonClick();
    } else {
      navigate(-1);
    }
  };

  return (
    <div
      className="flex flex-col items-center justify-center p-10"
      style={{ minHeight: "calc(100vh - 250px)" }}
    >
      {image && (
        <img
          src={image}
          alt="Illustration"
          className="w-44 h-44 lg:w-52 lg:h-52 mx-auto lg:mb-5"
        />
      )}
      <div className="space-y-4 max-w-[580px] lg:max-w-[620px] text-center">
        <p className="text-xl lg:text-2xl font-bold">{message}</p>
        {details && (
          <p className="text-base lg:text-lg text-gray-700">{details}</p>
        )}
      </div>
      <button
        onClick={handleClick}
        className="px-6 py-2 rounded-lg hover:opacity-90 transition-opacity mt-6 gap-3 flex items-center text-white bg-primary"
      >
        {buttonText}

        {buttonIcon}
      </button>
    </div>
  );
};

export default ErrorDisplay;
